import { render, staticRenderFns } from "./ButtonServiceUser.vue?vue&type=template&id=5e1a3f3c&scoped=true"
import script from "./ButtonServiceUser.vue?vue&type=script&lang=js"
export * from "./ButtonServiceUser.vue?vue&type=script&lang=js"
import style0 from "./ButtonServiceUser.vue?vue&type=style&index=0&id=5e1a3f3c&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e1a3f3c",
  null
  
)

export default component.exports